import React, { FunctionComponent } from 'react';

import { Icon, Content, Container } from './styles';

interface Props {
  icon?: any;
  small?: boolean;
  'data-cy'?: string;
}

const Title: FunctionComponent<Props> = ({ icon, children, small, 'data-cy': dataCy }) => (
  <Container small={small} data-cy={dataCy}>
    { icon && <Icon src={icon} /> }
    <Content>{children}</Content>
  </Container>
);

export default Title;
